import {Selector} from '@ngxs/store';
import {AdvertiserCampaignMediaState} from './advertiser-campaign-media.state';
import {IMediaItem} from '@interfaces/media';
import {MediaTypeEnum} from '@shared/enums/media-type.enum';
import {AdvertiserCampaignMediaModel} from '.';


export class AdvertiserCampaignMediaSelectors {
  @Selector([AdvertiserCampaignMediaState])
  static getAdvertiserMedia(state: AdvertiserCampaignMediaModel): IMediaItem[] {
    return state.media;
  }

  @Selector([AdvertiserCampaignMediaState])
  static getAdvertiserMediaSearch(state: AdvertiserCampaignMediaModel): string {
    return state.search;
  }

  @Selector([AdvertiserCampaignMediaState])
  static getAdvertiserMediaCurrentPage(state: AdvertiserCampaignMediaModel): number {
    return state.currentPage;
  }

  @Selector([AdvertiserCampaignMediaState])
  static getAdvertiserMediaPerPage(state: AdvertiserCampaignMediaModel): number {
    return state.itemsPerPage;
  }

  @Selector([AdvertiserCampaignMediaState])
  static getAdvertiserTotalMedia(state: AdvertiserCampaignMediaModel): number {
    return state.totalMediaNum;
  }

  @Selector([AdvertiserCampaignMediaState])
  static getAdvertiserMediaType(state: AdvertiserCampaignMediaModel): MediaTypeEnum | null {
    return state.mediaType;
  }

  @Selector([AdvertiserCampaignMediaState])
  static getAdvertiserSelectedMedia(state: AdvertiserCampaignMediaModel): IMediaItem | null {
    return state.selectedMedia;
  }
}
